// Tablist crossfade for sections/v2-size-scale.liquid (and the parked formats switcher concept).
class V2FormatTabs extends HTMLElement {
  #abort = new AbortController();

  connectedCallback() {
    const signal = this.#abort.signal;
    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    for (const tab of this.tabs) {
      tab.addEventListener('click', () => this.select(tab), { signal });
      tab.addEventListener('keydown', (e) => this.#onKey(e, tab), { signal });
    }
    const preload = () => {
      for (const img of this.querySelectorAll('img[loading="lazy"]')) img.loading = 'eager';
    };
    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) {
        preload();
        io.disconnect();
      }
    }, { rootMargin: '600px' });
    io.observe(this);
    signal.addEventListener('abort', () => io.disconnect());
  }

  disconnectedCallback() {
    this.#abort.abort();
  }

  /** @param {HTMLElement} tab @param {boolean} [focus] */
  select(tab, focus = false) {
    for (const t of this.tabs) {
      const on = t === tab;
      t.setAttribute('aria-selected', String(on));
      t.tabIndex = on ? 0 : -1;
      const panel = this.querySelector(`#${t.getAttribute('aria-controls')}`);
      if (!panel) continue;
      panel.classList.toggle('is-active', on);
      panel.toggleAttribute('inert', !on);
      if (on) panel.removeAttribute('aria-hidden');
      else panel.setAttribute('aria-hidden', 'true');
    }
    if (focus) tab.focus();
  }

  /** @param {KeyboardEvent} e @param {HTMLElement} tab */
  #onKey(e, tab) {
    const i = this.tabs.indexOf(tab);
    const map = { ArrowRight: i + 1, ArrowDown: i + 1, ArrowLeft: i - 1, ArrowUp: i - 1, Home: 0, End: this.tabs.length - 1 };
    if (!(e.key in map)) return;
    e.preventDefault();
    const next = this.tabs[(map[e.key] + this.tabs.length) % this.tabs.length];
    this.select(next, true);
  }
}

if (!customElements.get('v2-format-tabs')) customElements.define('v2-format-tabs', V2FormatTabs);
